module.exports = __webpack_public_path__ + "static/speaker3-bbe3ca92d11d8e5fb86ff81cddd97dc6.jpg";